import React,{useState,useEffect} from "react";
import { TextField, MenuItem, Tooltip } from "@material-ui/core";
import useStyles from "./styles";
import { FormInput } from "../../";
import { Grid} from "@material-ui/core";

import {pathOr, clone } from 'ramda';

const SYMBOL = {
  "=": "=",
  not_equal: "!=",
  greater_than: ">",
  greater_than_equals: ">=",
  less_than: "<",
  less_than_equals: "<=",
  between: "-",
};

const Currency = ({ field, onChange, errors = {}, value, small = false }) => {
  const classes = useStyles();
  let iserror = errors[field.name] ? true : false;
  const [fieldsData, setFieldsData] = useState(field);
  const [range, setRange] = useState(value);


  const renderOptions = () => {
    let optionsToRender = [];
    for (let optionKey in field.options) {
      optionsToRender.push(
        <MenuItem key={optionKey} value={optionKey}>
          <span>{field.options[optionKey]}</span>
        </MenuItem>,
      );
    }
    return optionsToRender;
  };

  const handleChange = (name,value,type='')=>{
		let initialValues = [];
    let initialValuesClone = clone(fieldsData);
// console.log(value,name,type)
		if(type==='range')
		{
			setRange(value);
// 			initialValues[field.field_key] = value; 
			initialValues['value'] = value; 
			let dateDoubleValue= ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
			let dateTripalValue= ['between'];
// initialValues[name]=value;
      if(dateDoubleValue.some(item =>  value === item)){
				initialValues[`start_range_${field.field_key}`] = '';
				initialValues[`end_range_${field.field_key}`] = '';
				
			}else if(dateTripalValue.some(item =>  value === item)){
				initialValues[`range_${field.field_key}`] = '';
			}
			// else
			// {
			// 	initialValues[`${field.field_key}_range_choice`] = '';
			// 	initialValues[`range_${field.field_key}`] = '';
			// }
		}
		
    initialValues[name] = value;
		setFieldsData({...fieldsData,...initialValues});
    // console.log("fieldsData",fieldsData)

    // onChange(fieldsData);
		
	}
  useEffect(() => onChange(clone(fieldsData)), [fieldsData]);
  const renderSubFields = () => {
    if (range && range !== "between") {
      return (
        // <Tooltip
        //   title={field.comment}
        //   disableHoverListener={field.comment ? false : true}
        //   placement="top-start"
        //   disableFocusListener={field.comment ? false : true}
        //   disableTouchListener={field.comment ? false : true}
        // >
        //   <TextField
        //     variant="outlined"
        //     id={field.name}
        //     name={field.name}
        //     required={field.required === 'true' ? true : false}
        //     size={small ? "small" : "medium"}
        //     label={SYMBOL[value]}
        //     InputLabelProps={{ shrink: true }}
        //     placeholder={field.options[range]}
        //     style={{ marginLeft: "8px" }}
        //     onChange={(value)=>handleChange(field.name,value, 'range')}			
        //     value={fieldsData['range_'+field.field_key]}
			
        //   />
        // </Tooltip>
        
        <Grid 
        container   
        direction="row"
        justify="center"
        alignItems="center">
  
        <Grid item xs="12"> 
<FormInput
field={{...field, field_key:`range_${field.name}`,name:`range_${field.name}`,type:'varchar',label:SYMBOL[range]}}
onChange={(value)=>handleChange(`range_${field.name}`,value, 'range')}					
small={true}
value={fieldsData[`range_${field.name}`]?fieldsData[`range_${field.name}`]:""}
// value={fieldsData['range_'+field.field_key]}
/>
</Grid>
</Grid>
      );
    }

    if (range && range === "between") {
      return (
        <Grid 
        container   
        direction="row"
        justify="center"
        alignItems="center"
        >
  
        <Grid item xs="5"> 
  
<FormInput
field={{...field, field_key:`start_range_${field.name}`,name:`start_range_${field.name}`,type:'varchar',label:SYMBOL[range]}}
onChange={(value)=>handleChange(`start_range_${field.name}`,value, 'start_range')}					
small={true}
value={fieldsData[`start_range_${field.name}`]?fieldsData[`start_range_${field.name}`]:""}
/>
          {/* <TextField
            variant="outlined"
            size={small ? "small" : "medium"}
            label={SYMBOL[range]}

            id={`start_range_${field.name}`}
            name={`start_range_${field.name}`}
            value={fieldsData[`start_range_${field.name}`] ? fieldsData[`start_range_${field.name}`] : null}
            InputLabelProps={{ shrink: true }}
            style={{ marginLeft: "8px" }}
            onChange={(value)=>handleChange(`start_range_${field.name}`,value,'start_range')}
      /> */}
  </Grid>
  <Grid item xs="2" >
          <span className={classes.betweenSeparator}>-</span>
          </Grid>
          <Grid item xs="5">
          <FormInput
field={{...field, field_key:`end_range_${field.name}`,name:`end_range_${field.name}`,type:'varchar',label:SYMBOL[range]}}
onChange={(value)=>handleChange(`end_range_${field.name}`,value, 'end_range')}					
small={true}
value={fieldsData[`end_range_${field.name}`]?fieldsData[`end_range_${field.name}`]:""}
/>
          {/* <TextField
            variant="outlined"
            size={small ? "small" : "medium"}
            label={SYMBOL[range]}
            id={`end_range_${field.name}`}
            name={`end_range_${field.name}`}
            value={fieldsData[`end_range_${field.name}`] ? fieldsData[`end_range_${field.name}`] : null}

            InputLabelProps={{ shrink: true }}
            style={{ marginLeft: "8px" }}
            onChange={(value)=>handleChange(`end_range_${field.name}`,value,'end_range')}
          /> */}
      </Grid>
      </Grid>
      );
    }
  };

  return (
    <Grid 
    container >
     <Grid 
        container   
        direction="row"
        justify="center"
        alignItems="center">
  
        <Grid item xs="12">       
       	<FormInput
					field={{...field, type:'enum'}}
					onChange={(value)=>handleChange(field.name,value, 'range')}					
					small={true}
					value={fieldsData[field.name]?fieldsData[field.name]:""}
					// value={range}
				/>
        </Grid>
        </Grid>
      {/* <TextField
        id={field.name}
        name={field.name}
        select
        label={field.label}
        error={iserror}
        helperText={errors[field.name] ? errors[field.name] : null}
        value={value ? value : " "}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        fullWidth
        size={small ? "small" : "medium"}
      >
        {renderOptions()}
      </TextField> */}

  <Grid 
        container   
        direction="row"
        justify="center"
        alignItems="center"
       style={{marginTop:'10px'}}
>
  
        <Grid item xs="12"> 
      {renderSubFields()}
      </Grid>
      </Grid>
      </Grid>
    );
};

export default Currency;
